import { useCallback, useEffect, useState } from "react"
import { callApi } from "../api"
import { useAccessToken } from "./useAccessToken"
import { getConfig } from "../config"

const { apiOrigin } = getConfig()

export const useApiCallback = (endpoint, origin = apiOrigin, run = true) => {
  const [apiState, setApiState] = useState({ data: null, error: null, loading: false })
  const { accessToken } = useAccessToken()

  const call = useCallback(
    async (endpoint, method = undefined, body = undefined) => {
      if (accessToken && endpoint) {
        setApiState((state) => ({
          ...state,
          loading: true
        }))
        const apiResult = await callApi(endpoint, accessToken, origin, method, body)
        setApiState((state) => ({
          ...state,
          ...apiResult
        }))
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accessToken]
  )

  useEffect(() => {
    if (run) {
      call(endpoint)
    }
  }, [call, endpoint, run])

  return { call, ...apiState }
}
